/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type APIResponseBase,
    APIResponseBaseFromJSON,
    APIResponseBaseToJSON,
} from '../models/APIResponseBase';
import {
    type PostTokenValidate200Response,
    PostTokenValidate200ResponseFromJSON,
    PostTokenValidate200ResponseToJSON,
} from '../models/PostTokenValidate200Response';
import {
    type RevokeTokenReq,
    RevokeTokenReqFromJSON,
    RevokeTokenReqToJSON,
} from '../models/RevokeTokenReq';
import {
    type ValidateTokenReq,
    ValidateTokenReqFromJSON,
    ValidateTokenReqToJSON,
} from '../models/ValidateTokenReq';

export interface PostTokenRevokeRequest {
    revokeTokenReq: RevokeTokenReq;
    slashIDSdkVersion?: string;
    slashIDRequiredConsistency?: PostTokenRevokeSlashIDRequiredConsistencyEnum;
    slashIDRequiredConsistencyTimeout?: number;
}

export interface PostTokenValidateRequest {
    validateTokenReq: ValidateTokenReq;
    slashIDSdkVersion?: string;
}

/**
 * 
 */
export class TokensApi extends runtime.BaseAPI {

    /**
     * Creates request options for postTokenRevoke without sending the request
     */
    async postTokenRevokeRequestOpts(requestParameters: PostTokenRevokeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['revokeTokenReq'] == null) {
            throw new runtime.RequiredError(
                'revokeTokenReq',
                'Required parameter "revokeTokenReq" was null or undefined when calling postTokenRevoke().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['slashIDSdkVersion'] != null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        }

        if (requestParameters['slashIDRequiredConsistency'] != null) {
            headerParameters['SlashID-Required-Consistency'] = String(requestParameters['slashIDRequiredConsistency']);
        }

        if (requestParameters['slashIDRequiredConsistencyTimeout'] != null) {
            headerParameters['SlashID-Required-Consistency-Timeout'] = String(requestParameters['slashIDRequiredConsistencyTimeout']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/token/revoke`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevokeTokenReqToJSON(requestParameters['revokeTokenReq']),
        };
    }

    /**
     * This endpoint revokes a SlashID user token. 
     * Revoke a user token
     */
    async postTokenRevokeRaw(requestParameters: PostTokenRevokeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.postTokenRevokeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * This endpoint revokes a SlashID user token. 
     * Revoke a user token
     */
    async postTokenRevoke(requestParameters: PostTokenRevokeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postTokenRevokeRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for postTokenValidate without sending the request
     */
    async postTokenValidateRequestOpts(requestParameters: PostTokenValidateRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['validateTokenReq'] == null) {
            throw new runtime.RequiredError(
                'validateTokenReq',
                'Required parameter "validateTokenReq" was null or undefined when calling postTokenValidate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['slashIDSdkVersion'] != null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/token/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateTokenReqToJSON(requestParameters['validateTokenReq']),
        };
    }

    /**
     * This endpoint validates a SlashID user token. The response indicates whether the token is valid and its expiration time if so. If the token is not valid, the reason is returned. 
     * Validate a user token
     */
    async postTokenValidateRaw(requestParameters: PostTokenValidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostTokenValidate200Response>> {
        const requestOptions = await this.postTokenValidateRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostTokenValidate200ResponseFromJSON(jsonValue));
    }

    /**
     * This endpoint validates a SlashID user token. The response indicates whether the token is valid and its expiration time if so. If the token is not valid, the reason is returned. 
     * Validate a user token
     */
    async postTokenValidate(requestParameters: PostTokenValidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostTokenValidate200Response> {
        const response = await this.postTokenValidateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const PostTokenRevokeSlashIDRequiredConsistencyEnum = {
    LocalRegion: 'local_region',
    AllRegions: 'all_regions'
} as const;
export type PostTokenRevokeSlashIDRequiredConsistencyEnum = typeof PostTokenRevokeSlashIDRequiredConsistencyEnum[keyof typeof PostTokenRevokeSlashIDRequiredConsistencyEnum];
